<div  usbLoadingSplash
[appLoading]="appLoading"
[fullscreen]="true"
[component]="'formPaxes'"
>





    <div *ngIf="data.typeAction" class="d-flex justify-content-between mx-auto px-3 pt-5" style="width: 97%">

        <h1 class="title mb-0 mt-2" style="line-height: 1 !important; color: black !important;" *ngIf="data.typeAction === 'New'">CREAR CLIENTE</h1>
        <h1 class="title mb-0 mt-2" style="line-height: 1 !important; color: black !important;" *ngIf="data.typeAction === 'Edit'">EDITAR CLIENTE</h1>

        <button type="button" class="close btn-closed" aria-label="Close" (click)="closeModal()">
          <span aria-hidden="true" style="font-size: 50px; font-weight: 100;">&times;</span>
        </button>
    </div>

<form *ngIf="_form && loadedClientInfoForm" [formGroup]="_form"  autocomplete="off">
  <div class="row font-poppins">
    <div class="col-8 col-md-8 col-lg-8 col-xl-8" [ngClass]="{'col-12': data.typeAction, 'col-lg-12': data.typeAction, 'col-md-12': data.typeAction, 'col-xl-12': data.typeAction}">
      <span *ngIf="!data" class="mb-3" style="font-size: 1.65rem" [ngStyle]="{ color: formPaxesReservationData.getClientsSettingAppBooking?.clients_setting_global?.color_main_2 }"
        >SELECCIONA HABITACIÓN PARA PASAJERO
      </span>
      <accordion [closeOthers]="true" class="mt-3 client-modal" >
        <accordion-group
          formArrayName="paxes"
          *ngFor="let adult of paxes; let i = index"
          [isOpen]="(i == 0 && loadedClientInfoForm ? true : false) || data.typeAction"
          style="margin-bottom: 10px"
          >
          <!-- (click)="expandedValueForm(i)" -->
          <div accordion-heading *ngIf="!data.typeAction">
            <div class="row ml-0 mr-0 mb-1" >
              <div class="col-8 pl-0 pr-1">
                <div
                  class="p-2 d-flex align-items-center justify-content-between pax-header"
                  style="height: 53px"
                  [ngStyle]="{ 'background-color': formPaxesReservationData.getClientsSettingAppBooking?.clients_setting_global?.color_main_2 }"
                  >
                  <div class="d-flex flex-column">
                    <div class="pull-left float-left text-uppercase ml-4 title-accord" style="font-size: 16px !important;margin-bottom: 5px;">{{ adult?.title }}</div>
                    <div class="pull-left float-left text-uppercase ml-4 title-accord" style="font-size: 14px !important">{{ getNamePaxes(i, adult.title) }} {{ adult.type === 'children' ? ', ' + getAge(_form.get(['paxes', i, 'birth_date'])?.value, i) : ''}}</div>
                  </div>
                  <i class="fas fa-caret-down mr-2"></i>
                </div>
              </div>
              <div
                class="col-4 p-2 d-flex justify-content-between align-items-center checker"
                style="border-radius: 5px; cursor: pointer"
                [ngClass]="{ 'checker-green': checkProductConfirm(i) }"
              >
                <object
                  *ngIf="!checkProductConfirm(i)"
                  type="image/svg+xml"
                  data="/assets/img/app/little-icons/timer_bco.svg"
                  width="30px"
                  height="30px"
                ></object>
                <span *ngIf="checkProductConfirm(i)" class="icon-check"></span>
                <div class="d-flex flex-column align-items-end">
                  <span class="state" *ngIf="checkProductConfirm(i)">Listo</span>
                  <span class="state" *ngIf="!checkProductConfirm(i)">Pendiente</span>
                  <span (click)="removeOptionalForm(i)"
                        style="font-family: 'Poppins';font-size: 12px;font-weight: 400;cursor: pointer; margin-top: 5px;"
                        *ngIf="_form?.value?.paxes[i]?.paxOptional">Eliminar formulario</span>
                </div>
              </div>
            </div>
          </div>
          <div [formGroupName]="i" class="pr-3 adjust-container-form-paxes" [ngClass]="{'mx-4': data.typeAction}" >


            <div class="row align-items-center justify-content-between" style="padding-bottom: 40px;">
            <ng-container  *ngIf="shouldShowClientSelector(i)">
              <div class="form-group  sm-gutters" style="width: 100%"  *ngIf="clientExist(formPaxesReservationData.clientsAssociated)">
              <!-- <div class="form-group col-4 sm-gutters"> -->
                <label *ngIf="!_form?.value?.paxes[i]?.clientSelected && i !== 0 " class="font-weight-bold font-poppins" for="title" style="font-size: small">{{(associatedFilterView[i] && associatedClients && associatedClients.length > 0) ? 'Asociados' : 'Clientes'}}</label>
                <label *ngIf="_form?.value?.paxes[i]?.clientSelected && i !== 0" class="font-weight-bold font-poppins" for="title" style="font-size: small">{{(associatedFilterView[i] && associatedClients && associatedClients.length === 0) ? 'Cliente seleccionado' : 'Asociados seleccionado'}}</label>

                <label *ngIf="!_form?.value?.paxes[i]?.clientSelected && i == 0 " class="font-weight-bold font-poppins" for="title" style="font-size: small">Clientes </label>
                <label *ngIf="_form?.value?.paxes[i]?.clientSelected && i == 0" class="font-weight-bold font-poppins" for="title" style="font-size: small">Cliente seleccionado</label>


                <div class="d-flex align-items-center" >
                  <div class="d-flex  align-items-center px-3 py-2" style="background-color: #ececec; border-radius: 4px;width: 67%" *ngIf="_form?.value?.paxes[i]?.clientSelected">
                     <p class="mb-0" style="font-family: 'Rubik', serif; font-size: 16px; font-weight: 400" >
                      {{_form?.value?.paxes[i]?.first_name ? _form?.value?.paxes[i]?.first_name : _form?.value?.paxes[i]?.last_name ? '' : 'Nombre sin definir'}} {{_form?.value?.paxes[i]?.last_name ? _form?.value?.paxes[i]?.last_name : ''}}  {{_form?.value?.paxes[i]?.email  ? '- ' + _form?.value?.paxes[i]?.email : ""}} <span *ngIf="_form?.value?.paxes[i]?.document_type_id">{{_form?.value?.paxes[i]?.document_type_id === 4 ? ' - DNI: ' : " - Pasaporte: "}}</span> {{_form?.value?.paxes[i].document_number ? _form?.value?.paxes[i].document_number : "- Completar DNI"}}
                    </p>
                  </div>




                    <input *ngIf="_form?.get('paxes.' + i + '.clientSelected')?.value === null || !_form?.get('paxes.' + i + '.clientSelected')?.value"
                                              name="clientSelected"
                                              id="my-select-{{i}}"
                                              matInput
                                              maxlength="20"
                                              class="form-control custom-select select-clientes"
                                              style="background-color: white;width: 67%"
                                              #destination
                                              [formControl]="clientSearchControls[i]"
                                              placeholder="{{getPlaceholderClients(i)}}"
                                              [matAutocomplete]="autoDestination">
                          <mat-autocomplete #autoDestination="matAutocomplete"
                                              (optionSelected)="selectClientFunction($event.option.value, i)">

                                <mat-option [value]="null" disabled selected>Seleccionar Cliente</mat-option>

                                <!-- Usar la función filtrada en lugar del array completo -->
                                <ng-container *ngIf="(filteredClients[i] | async) as clients">


                                  <ng-container *ngIf="clients.length === 0">
                                      <!-- Mostrar mensaje de "sin resultados" con diferentes mensajes según el caso -->
                                      <mat-option disabled>
                                          <div class="d-flex flex-column align-items-center p-2">
                                              <span style="color: #999;">
                                                  <ng-container *ngIf="clientSearchControls[i]?.value">
                                                      No se encontraron clientes con "{{ clientSearchControls[i].value }}"
                                                  </ng-container>
                                                  <ng-container *ngIf="!clientSearchControls[i]?.value">
                                                      <ng-container *ngIf="paxes[i]?.type === 'children'">
                                                          No hay niños asociados con la edad requerida ({{ paxes[i]?.age }} años)
                                                      </ng-container>
                                                      <ng-container *ngIf="paxes[i]?.type !== 'children'">
                                                          No hay clientes asociados disponibles
                                                      </ng-container>
                                                  </ng-container>
                                              </span>
                                          </div>
                                      </mat-option>
                                  </ng-container>

                                      <ng-container *ngFor="let client of clients">
                                 <!-- Cliente ya seleccionado en ESTE pax -->
                                    <mat-option *ngIf="client.selected && client.paxSelect == i" [value]="client.id" disabled>
                                        <span style="font-weight: 600;">{{ client.first_name }} {{ client.last_name ? client.last_name : "" }}</span>
                                        ({{client.email ? client.email : ""}}
                                        <span style="font-size: 14px;font-weight: 400;" *ngIf="client.document_number">
                                            {{client.document_type_id === 4 ? ' - DNI: ' : " - Pasaporte: "}}
                                            {{client.document_number ? client.document_number : ""}}
                                        </span>)
                                        <span style="color: #666; font-style: italic;"> - Ya seleccionado</span>
                                    </mat-option>

                                    <!-- Cliente disponible -->
                                    <mat-option *ngIf="!client.selected && client.available" [value]="client.id">
                                        <span style="font-weight: 600;">{{ client.first_name }} {{ client.last_name ? client.last_name : "" }}</span>
                                        ({{client.email ? client.email : ""}}
                                        <span style="font-size: 14px;font-weight: 400;" *ngIf="client.document_number">
                                            {{client.document_type_id === 4 ? ' - DNI: ' : " - Pasaporte: "}}
                                            {{client.document_number ? client.document_number : ""}}
                                        </span>)
                                        <!-- <span style="color: #28a745; font-size: 12px;">
                                            ({{client.age}} años)
                                        </span> -->
                                    </mat-option>

                                    <!-- Cliente no disponible (seleccionado en otro pax) -->
                                    <mat-option *ngIf="client.selected && client.paxSelect !== i" disabled>
                                        <span style="color: #999;">{{ client.first_name }} {{ client.last_name ? client.last_name : "" }}</span>
                                        <span style="color: #666; font-style: italic;"> - Ya seleccionado en otro pasajero</span>
                                    </mat-option>
                                  </ng-container>



                                </ng-container>

                            </mat-autocomplete>

                  <div class="d-flex col-2 sm-gutters"  *ngIf="_form?.value?.paxes[i]?.clientSelected">
                    <button
                      (click)="resetClient(i, adult)"
                      *ngIf="formPaxesReservationData.booleanHeadline"
                      type="button"
                      class="btn float-right p-0 d-flex justify-content-center align-items-center ml-1"
                      style="
                        cursor: pointer;
                        width: 40px;
                        height: 38px;
                        border-radius: 4px;
                        background-color: #ffffff;
                        border: 1px solid #ced4da;
                      "
                    >
                      <i class="icon-cesto"></i>
                    </button>
                  </div>
                  <div *ngIf="!_form?.value?.paxes[i]?.clientSelected && i !== 0  && associatedClients && associatedClients.length > 0" class="d-flex align-items-center" style="gap:.5em;width: 170px">
                    <label
                        class="mb-0 ml-2"
                        style="
                          margin-top: 5px;
                          border-radius: 6px;
                          width: fit-content;
                          height: 22px;
                          width: 22px;
                          padding-left: 1px;
                          padding-top: 0.7px;
                          border: 1px solid black;
                        "
                    >
                      <input
                       type="checkbox"
                       class="black-checkbox"
                      (click)="changeViewsClientsSelected(i)"
                      [checked]="!associatedFilterView[i]"
                      *ngIf="formPaxesReservationData.booleanHeadline"
                      >
                    </label>
                      <p class="fw-semibold small mb-0" style="line-height: 1;">{{ associatedFilterView ? 'Otros clientes' : 'Ver asociados'}}</p>

                  </div>

                  <div class="col-3 d-flex flex-column align-items-end" *ngIf="(i === 1 && adult.type === 'adult')">

                    <button
                            type="button"
                            class="btn btn-i btn-actualizar d-flex justify-content-center align-items-center rounded"
                            style="max-width: 175px;width:100%;height: 36px;"
                            [ngStyle]="{'background-color': formPaxesReservationData.getClientsSettingAppBooking?.clients_setting_global?.color_main_1}"
                            tooltip="Los datos copiados son país, región, ciudad, dirección, télefono"
                            placement="bottom">
                            <p class="mb-0"  style="font-family: 'Rubik', serif;font-size: 14px; font-weight: 400 !important;cursor:pointer; max-width: 175%px;width: 100%;" (click)="setPaxAdults()">Copiar datos de títular</p>
                    </button>
                  </div>

                </div>
              </div>

            </ng-container >


            </div>

<!--

  TITULO, NOMBRE, APELLIDO Y GENERO

-->

<!--
  TITULO
-->
            <div class="row">
              <div class="col-5 sm-gutters" >
                <div class="form-group">
                  <label
                          for="title"
                          class="font-weight-bold font-poppins"
                          style="font-size: small"
                    >
                      Título y nombre/s
                    <sup class="required-marker"> * </sup>
                  </label>
                  <div class="row d-flex justify-content-between m-0" style="position: relative">
                    <select
                             #nameInput
                              name="name_{{i}}"
                              id="name_{{i}}"
                              autocomplete="off"
                              autocomplete="new-password"
                              aria-autocomplete="none"
                              (focus)="disableBraveAutofill(nameInput)"
                            class="form-control-sm custom-select"
                            style="width: 41%"
                            [ngClass]="{
                                        'is-invalid': _form?.value?.paxes[i]?.title === null,
                                        'is-valid':  _form?.value?.paxes[i]?.title !== null
                                      }"
                            [ngStyle]="getStyles(i)"
                            formControlName="title"
                            aria-label="title"
                            aria-required="true"

                            required>
                      <option
                              selected
                              disabled
                              value="null"
                      >
                        Título
                      </option>
                      <option *ngFor="let title of titles"
                              [value]="title.id">
                        {{ title.name }}
                      </option>
                    </select>

<!--
  NOMBRE
-->



                    <input
                           #firstNameInput
                              name="first_name_{{i}}"
                              id="first_name_{{i}}"
                              autocomplete="off"
                              autocomplete="new-password"
                              aria-autocomplete="none"
                              (focus)="disableBraveAutofill(firstNameInput)"
                          class="form-control"
                          style="width: 56%;"
                          [ngClass]="{
                                      'is-invalid':
                                                    _form.value.paxes[i].first_name === '' ||
                                                    _form.value.paxes[i].first_name === null ||
                                                    _form.get(['paxes', i, 'first_name'])?.errors?.pattern ||
                                                    _form.get(['paxes', i, 'first_name'])?.hasError('minlength'),
                                      'is-valid':
                                                    (_form.value.paxes[i].first_name !== '' ||
                                                    _form.value.paxes[i].first_name !== null) &&
                                                    !_form.get(['paxes', i, 'first_name'])?.errors?.pattern &&
                                                    !_form.get(['paxes', i, 'first_name'])?.hasError('minlength')
                                    }"
                          [ngStyle]="getStyles(i)"
                          type="text"
                          formControlName="first_name"
                          aria-label="first_name"
                          aria-required="true"
                          autocapitalize="none"
                          (keydown)=" blockInvalidKeys($event, 'name')"
                          [maxLength]="50"
                          (input)="inputValueName(i)"
                          placeholder="Nombre/s"
                          required
                      />
                      <span
                            style="font-size: 14px; color: #e93a55; position: absolute; bottom: -24px; left: 10em;"
                            *ngIf="_form.get(['paxes', i, 'first_name'])?.errors?.pattern"
                          >
                            Ingresar letras
                      </span>
                      <span
                        style="font-size: 14px; color: #e93a55; position: absolute; bottom: -24px; left: 10px;"
                        *ngIf="_form.get(['paxes', i, 'first_name'])?.hasError('minlength')"
                      >
                      Mínimo 2 letras
                      </span>
                  </div>
                </div>
              </div>

<!--
  APELLIDO
-->
              <div class="col-3 sm-gutters">
                <div class="form-group" style="position: relative">
                  <label for="last_name"
                          class="font-weight-bold font-poppins"
                          style="font-size: small"
                  >
                    Apellido/s
                    <sup class="required-marker"> * </sup></label
                  >
                  <input
 #lastNameInput
                              name="last_name_{{i}}"
                              id="last_name_{{i}}"
                              autocomplete="off"
                              autocomplete="new-password"
                              aria-autocomplete="none"
                              (focus)="disableBraveAutofill(lastNameInput)"
                    class="form-control"
                    [ngClass]="{
                                'is-invalid':
                                              _form.value.paxes[i].last_name == null ||
                                              _form.value.paxes[i].last_name == '' ||
                                              _form.get(['paxes', i, 'last_name'])?.errors?.pattern ||
                                              _form.get(['paxes', i, 'last_name'])?.hasError('minlength'),
                                'is-valid':
                                              (_form.value.paxes[i].last_name !== null ||
                                              _form.value.paxes[i].last_name !== '') &&
                                              !_form.get(['paxes', i, 'last_name'])?.errors?.pattern &&
                                              !_form.get(['paxes', i, 'last_name'])?.hasError('minlength')
                              }"
                    [ngStyle]="getStyles(i)"
                    type="text"
                    formControlName="last_name"
                    aria-label="last_name"
                    aria-required="last_name"
                    (input)="inputValueName(i)"
                    (keydown)=" blockInvalidKeys($event, 'name')"
                    [maxLength]="50"
                    placeholder="Apellido/s"
                    autocapitalize="none"
                    required
                  />
                  <span
                    style="font-size: 14px; color: #e93a55; position: absolute; bottom: -24px; left: 10px;"
                    *ngIf="_form.get(['paxes', i, 'last_name'])?.errors?.pattern"
                  >
                  Ingresar letras
                  </span>
                  <span
                    style="font-size: 14px; color: #e93a55; position: absolute; bottom: -24px; left: 10px;"
                    *ngIf="_form.get(['paxes', i, 'last_name'])?.hasError('minlength')"
                  >
                  Mínimo 2 letras
                  </span>


                </div>
              </div>


<!--
  GENERO
-->

              <div class="col-4 sm-gutters">
                <div class="form-group" *ngIf="editDataPax[i]">
                  <label
                        for="gender"
                        class="font-weight-bold font-poppins"
                        style="font-size: small"
                  >
                    Género
                    <span *ngIf="i<2 && adult.type !== 'children'"><sup class="required-marker"> * </sup></span></label
                  >
                  <select
                          id="gender"
                          name="gender"
                          class="form-control-sm custom-select"

                          [ngClass]="{
                                      'is-invalid':i<2 && adult.type !== 'children' &&  _form.value.paxes[i].gender == null,
                                      'is-valid': i<2 && adult.type !== 'children' && _form.value.paxes[i].gender != null
                                    }"
                          [ngStyle]="getStyles(i)"
                          formControlName="gender"
                          aria-label="gender"
                          aria-required="gender"
                          autocomplete="off"
                          required>
                    <option value="null" selected disabled>Género</option>
                    <option value="F">Femenino</option>
                    <option value="M">Masculino</option>
                    <option value="X">No Especificado</option>
                    <option value="U">Prefiero no decirlo</option>
                  </select>
                </div>



                <div class="form-group" *ngIf="(i > 1 || adult.type === 'children') && !editDataPax[i]">
                    <label class="font-weight-bold font-poppins" style="font-size: small" for="birth_date"
                      >Fecha de nacimiento <sup class="required-marker"> * </sup></label
                      >
                        <input
                            *ngIf="adult.type == 'adult'"
                            id="birth_date"
                            name="birth_date"
                            class="form-control"
                            [ngClass]="{
                                        'is-invalid':
                                                    !_form.get('paxes').get(i.toString()).get('type').value && !_form.get('paxes').get(i.toString()).get('birth_date').touched ||
                                                    _form.get('paxes').get(i.toString()).get('birth_date').value === null ||
                                                    (_form.get('paxes.' + i + '.birth_date').errors && _form.get('paxes.' + i + '.birth_date').errors.customErrorBirthDate),
                                        'is-valid':
                                                    _form.get('paxes').get(i.toString()).get('type').value ||
                                                    _form.get('paxes').get(i.toString()).get('birth_date').touched ||
                                                    _form.get('paxes').get(i.toString()).get('birth_date').value !== null
                                      }"
                            [ngStyle]="getStyles(i)"
                            type="text"
                            formControlName="birth_date"
                            aria-label="birth_date"
                            aria-required="true"
                            bsDatepicker
                            readonly
                            [maxDate]="formPaxesReservationData.minDateAdult"
                            [minDate]="formPaxesReservationData.maxDateAdult"
                            [bsConfig]="dpConfig"
                            autocomplete="off"
                            (bsValueChange)="changeDateClientAssociated($event)"
                            placeholder="Fecha de Nacimiento"
                            required
                      />
                      <input
                          *ngIf="adult.type == 'children' "
                          id="birth_date"
                          name="birth_date"
                          class="form-control"
                          [ngClass]="{
                                      'is-invalid':
                                                    !_form.get('paxes').get(i.toString()).get('type').value && !_form.get('paxes').get(i.toString()).get('birth_date').touched ||
                                                    (_form.get('paxes.' + i + '.birth_date').errors && _form.get('paxes.' + i + '.birth_date').errors.customErrorBirthDate),
                                      'is-valid':
                                                    _form.get('paxes').get(i.toString()).get('type').value ||
                                                    _form.get('paxes').get(i.toString()).get('birth_date').touched
                                    }"
                          [ngStyle]="getStyles(i)"
                          type="text"
                          formControlName="birth_date"
                          aria-label="birth_date"
                          aria-required="true"
                          bsDatepicker
                          readonly
                          [minDate]="getChildMinDate(paxes[i]?.age, paxes[i]?.arrivalDate, paxes[i]?.arrivalDateString)"
                          [maxDate]="getChildMaxDate(paxes[i]?.age, paxes[i]?.arrivalDate, paxes[i]?.arrivalDateString)"
                          [bsConfig]="childDatepickerConfig"
                          autocomplete="off"
                          placeholder="Fecha de Nacimiento"
                          required
                    />


<small *ngIf="adult.type == 'children'" class="form-text text-muted" style="font-size: 11px; margin-top: 4px;">
  Seleccione día y mes. El año será {{_form.get(['paxes', i, 'birth_date'])?.value | date: 'yyyy'}} según la edad del niño.
</small>


                </div>


              </div>
            </div>

            <span *ngIf="(i >= 2 || adult.type === 'children') && !editDataPax[i]" class="required-marker">* Campos Obligatorios</span>

            <ng-container *ngIf="i >= 2 || adult.type === 'children'">
                <div class="d-flex justify-content-md-between align-items-center mb-2">
                  <p class="mb-2 mt-3" style="font-family: 'Poppins', sans-serif; font-weight: 600;">{{!editDataPax[i] ? 'Otros datos' : ''}}</p>
                  <button
                      type="button"
                      class="btn btn-i btn-actualizar d-flex justify-content-center align-items-center rounded"
                      style="width: 125px;height: 34px;"
                      (click)="editDataPassenger(i)"
                      [ngStyle]="{'background-color': formPaxesReservationData.getClientsSettingAppBooking?.clients_setting_global?.color_main_1}"
                      tooltip="Los datos copiados son país, región, ciudad, dirección, télefono"
                      placement="bottom">
                      <p class="mb-0"  style="font-family: 'Rubik', serif;font-size: 14px; font-weight: 400 !important;cursor:pointer">{{!editDataPax[i] ? 'Editar datos' : 'Ocultar edición'}}</p>
                  </button>
                </div>


              <div *ngIf="!editDataPax[i]" class="table-responsive">
                <table class="table table-sm table-borderless" style="background: #f8f9fa; border-radius: 8px;">
                  <tbody>
                    <tr>
                      <td width="30%" class="text-muted small p-3">
                        <i class="fas fa-birthday-cake me-2" [ngStyle]="{'color': formPaxesReservationData.getClientsSettingAppBooking?.clients_setting_global?.color_main_1}"></i>
                        Edad:
                      </td>
                      <td class="fw-semibold small p-3">{{ getAge(_form.get(['paxes', i, 'birth_date'])?.value, i)}}</td>

                      <td width="30%" class="text-muted small p-3">
                        <i class="fas fa-envelope me-2" [ngStyle]="{'color': formPaxesReservationData.getClientsSettingAppBooking?.clients_setting_global?.color_main_1}"></i>
                        Email:
                      </td>
                      <td class="fw-semibold small p-3">{{ _form.get(['paxes', i, 'email'])?.value || 'Completar titular' }}</td>
                    </tr>
                    <tr>
                      <td class="text-muted small p-3">
                        <i class="fas fa-flag me-2" [ngStyle]="{'color': formPaxesReservationData.getClientsSettingAppBooking?.clients_setting_global?.color_main_1}"></i>
                        Nacionalidad:
                      </td>
                      <td class="fw-semibold small p-3">{{ selectedIsCountry[i] || 'Completar titular' }}</td>

                      <td class="text-muted small p-3">
                        <i class="fas fa-phone me-2" [ngStyle]="{'color': formPaxesReservationData.getClientsSettingAppBooking?.clients_setting_global?.color_main_1}"></i>
                        Teléfono:
                      </td>
                      <td class="fw-semibold small p-3">{{ _form.get(['paxes', i, 'phone_code'])?.value }} {{ _form.get(['paxes', i, 'phone'])?.value || 'Completar titular' }}</td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </ng-container>

<!--

  FECHA DE NACIMIENTO

-->

            <div class="row">
              <ng-container *ngIf="(i > 0 || data.fromAssociates) && editDataPax[i]">
                <div class="col-6 sm-gutters" style="margin-top: 40px" [ngStyle]="{'margin-top': data.typeAction ? '10px' : '40px'}">
                  <div class="form-group">
                    <label class="font-weight-bold font-poppins" style="font-size: small" for="birth_date"
                      >Fecha de nacimiento <sup class="required-marker"> * </sup></label
                    >
                    <input
                          *ngIf="adult.type == 'adult' && editDataPax[i]"
                          id="birth_date"
                          name="birth_date"
                          class="form-control"
                          [ngClass]="{
                                      'is-invalid':
                                                  !_form.get('paxes').get(i.toString()).get('type').value && !_form.get('paxes').get(i.toString()).get('birth_date').touched ||
                                                  _form.get('paxes').get(i.toString()).get('birth_date').value === null ||
                                                  (_form.get('paxes.' + i + '.birth_date').errors && _form.get('paxes.' + i + '.birth_date').errors.customErrorBirthDate),
                                      'is-valid':
                                                  _form.get('paxes').get(i.toString()).get('type').value ||
                                                  _form.get('paxes').get(i.toString()).get('birth_date').touched ||
                                                  _form.get('paxes').get(i.toString()).get('birth_date').value !== null
                                    }"
                          [ngStyle]="getStyles(i)"
                          type="text"
                          formControlName="birth_date"
                          aria-label="birth_date"
                          aria-required="true"
                          bsDatepicker
                          readonly
                          [maxDate]="formPaxesReservationData.minDateAdult"
                          [minDate]="formPaxesReservationData.maxDateAdult"
                          [bsConfig]="dpConfig"
                          autocomplete="off"
                          (bsValueChange)="changeDateClientAssociated($event)"
                          placeholder="Fecha de Nacimiento"
                          required
                    />
                    <input
                          *ngIf="adult.type == 'children' && editDataPax[i]"
                          id="birth_date"
                          name="birth_date"
                          class="form-control"
                          [ngClass]="{
                                      'is-invalid':
                                                    !_form.get('paxes').get(i.toString()).get('type').value && !_form.get('paxes').get(i.toString()).get('birth_date').touched ||
                                                    (_form.get('paxes.' + i + '.birth_date').errors && _form.get('paxes.' + i + '.birth_date').errors.customErrorBirthDate),
                                      'is-valid':
                                                    _form.get('paxes').get(i.toString()).get('type').value ||
                                                    _form.get('paxes').get(i.toString()).get('birth_date').touched
                                    }"
                          [ngStyle]="getStyles(i)"
                          type="text"
                          formControlName="birth_date"
                          aria-label="birth_date"
                          aria-required="true"
                          bsDatepicker
                          readonly
                        [minDate]="getChildMinDate(paxes[i]?.age, paxes[i]?.arrivalDate, paxes[i]?.arrivalDateString)"
[maxDate]="getChildMaxDate(paxes[i]?.age, paxes[i]?.arrivalDate, paxes[i]?.arrivalDateString)"
                           [bsConfig]="childDatepickerConfig"
                          autocomplete="off"
                          placeholder="Fecha de Nacimiento"
                          required
                    />
                    <small *ngIf="adult.type == 'children'" class="form-text text-muted" style="font-size: 11px; margin-top: 4px;">
  Seleccione día y mes. El año será {{_form.get(['paxes', i, 'birth_date'])?.value | date: 'yyyy'}} según la edad del niño.
</small>
                  </div>
                </div>
                <div class="col-6 sm-gutters" style="margin-top: 40px" [ngStyle]="{'margin-top': data.typeAction ? '10px' : '40px'}">
                  <div class="form-group">
                    <label class="font-weight-bold font-poppins" for="last_name" style="font-size: small"
                      >Relación <span *ngIf="i < 1"><sup class="required-marker"> * </sup></span></label
                    >
                    <select

                            id="relation_ship"
                            name="relation_ship"
                            [ngClass]="{
                                      'is-invalid':
                                                    !_form.get('paxes').get(i.toString()).get('relation_ship').value,
                                      'is-valid':
                                                    _form.get('paxes').get(i.toString()).get('relation_ship').value
                                    }"
                            class="form-control-sm custom-select"
                            [ngStyle]="getStyles(i, 'relation_ship')"
                            formControlName="relation_ship"
                            aria-label="relation_ship"
                            (change)="setRelationShip($event.target.value)"
                    >
                    <option value="null" disabled selected>Seleccionar</option>
                    <ng-container *ngIf="adult.type === 'adult'">
                      <ng-container *ngFor="let relation of formPaxesReservationData.relationShips">
                        <option [value]="relation.id">
                          {{ relation.relation_ship_name }}
                        </option>
                      </ng-container>
                    </ng-container>
                    <ng-container *ngIf="adult.type === 'children'">
                      <ng-container *ngFor="let relation of formPaxesReservationData.relationChild">
                        <option [value]="relation.id"
                          >
                          {{ relation.relation_ship_name }}
                        </option>
                      </ng-container>
                    </ng-container>
                    </select>
                  </div>
                </div>
              </ng-container>
            </div>
            <div class="row" style="margin-top: 50px" [ngStyle]="{'margin-top': data.typeAction ? '10px' : '50px'}">
              <ng-container *ngIf="(i > 0 || data.fromAssociates === true) && editDataPax[i]">
                <div class="col-6 sm-gutters" >
                  <div class="form-group position-relative">
                    <label class="font-weight-bold font-poppins" for="document_type_id" style="font-size: small"
                      >Documento y N° de Documento <span *ngIf="i < 2 && adult.type !=='children'"><sup class="required-marker" > * </sup></span></label
                    >

                    <div class="row d-flex ml-0 position-relative">
                      <select
                        *ngIf="adult.type === 'adult' && editDataPax[i]"
                        formControlName="document_type_id"
                        id="document_type_id"
                        #document_type_id
                        class="form-control-sm custom-select"
                        [ngStyle]="getStyles(i)"
                        (change)="verifyExistWithDebounce($event.target.value, 'type_document', i)"
                        [ngClass]="{'is-invalid':i<2 && _form.value.paxes[i].document_type_id == null, 'is-valid': i<2 && _form.value.paxes[i].document_type_id !== null}"
                        style="width: 45%"
                      >
                        <option value="null" selected disabled>Tipo Doc</option>
                        <ng-container *ngFor="let document of formPaxesReservationData.documentTypes">
                          <option [value]="document.id">{{document.name}}</option>
                        </ng-container>
                        <!-- <option value="4">DNI</option>
                        <option value="5">PASAPORTE</option> -->
                      </select>
                      <input
                            *ngIf="adult.type == 'adult' && editDataPax[i]"
                            #document_number
                              name="document_number_{{i}}"
                              id="document_number_{{i}}"
                              autocomplete="off"
                              autocomplete="new-password"
                              aria-autocomplete="none"
                              (focus)="disableBraveAutofill(document_number)"
                            formControlName="document_number"

                            (keydown)="onDocumentKeyDown($event, i)"
                            (input)="verifyExistWithDebounce($event.target.value, 'document_number', i);"
                            [ngClass]="{
                              'is-invalid': i < 2 && (
                                !_form.value.paxes[i].document_number ||
                                _form.value.paxes[i].document_number === '' ||
                                (_form.get('paxes.' + i + '.document_number')?.errors && (
                                  _form.get('paxes.' + i + '.document_number')?.errors['customErrorKey'] ||
                                  _form.get('paxes.' + i + '.document_number')?.errors['duplicateErrorKey']
                                ))
                              ),
                              'is-valid': i < 2 && _form.value.paxes[i].document_number &&
                                          _form.value.paxes[i].document_number !== '' &&
                                          !_form.get('paxes.' + i + '.document_number')?.errors
                            }"
                            [ngStyle]="getStyles(i)"
                            type="text"
                            class="form-control"
                            style="width: 50%; margin-left: 7px"
                            id="document_input_emit_missmatch"
                            autocapitalize="none"
                            placeholder="N° de Documento"
                            min="0"
                            required
                          />
                      <select
                        *ngIf="adult.type === 'children' && editDataPax[i]"
                        formControlName="document_type_id"
                        (change)="verifyExistWithDebounce($event.target.value, 'type_document', i)"
                        id="document_type_id"
                        [ngStyle]="getStyles(i)"
                        class="form-control custom-select"
                        style="width: 45%"
                      >
                        <ng-container *ngFor="let document of formPaxesReservationData.documentTypes">
                          <option [value]="document.id">{{document.name}}</option>
                        </ng-container>
                      </select>
                      <input
                          *ngIf="adult.type == 'children' && editDataPax[i]"
                          formControlName="document_number"
                          (keydown)="_form.get('paxes.' + i + '.document_type_id').value === '4' || _form.get('paxes.' + i + '.document_type_id').value === 4 ? blockInvalidKeys($event, 'DNI') : blockInvalidKeys($event, 'alfanumerico')"
                          (input)="verifyExistWithDebounce($event.target.value, 'document_number', i);"
                          type="text"
                          class="form-control"
                          style="width: 50%; margin-left: 7px"
                          id="document_number_child"
                          autocapitalize="none"
                          autocomplete="random-string"
                          [ngStyle]="getStyles(i)"
                          placeholder="N° de Documento"
                      />
                      <span
                            *ngIf="_form.get('paxes.' + i + '.document_number').errors && _form.get('paxes.' + i + '.document_number').errors.customErrorKey"
                            style="font-size: 14px; color: #e93a55; position: absolute; bottom: -24px; left: 20px;"
                            >Este número ya fue registrado</span
                      >
                      <span
                      *ngIf="_form.get('paxes.' + i + '.document_number').errors && _form.get('paxes.' + i + '.document_number').errors.duplicateErrorKey"
                      style="font-size: 14px; color: #e93a55; position: absolute; bottom: -24px; left: 20px;"
                      >Duplicado en formularios</span>
                      <span
                            style="font-size: 14px; color: #e93a55; position: absolute; bottom: -24px; left: 10px;"
                            *ngIf="(_form.get(['paxes', i, 'document_number'])?.hasError('nonNegative') || _form.get(['paxes', i, 'document_number'])?.hasError('pattern')) &&
                                    (_form.get('paxes.' + i + '.document_type_id').value === '4' || _form.get('paxes.' + i + '.document_type_id').value === 4) "
                          >
                         Ingresar números. No puede ser negativo
                  </span>
                    </div>
                  </div>
                </div>

                <div *ngIf="editDataPax[i]" class="col-6 sm-gutters" style="position: relative;">
                  <div class="form-group">
                    <label class="font-weight-bold font-poppins" for="email" style="font-size: small"
                      >Email <span *ngIf="i < 1 && adult.type !=='children'"><sup class="required-marker" > * </sup></span></label
                    >
                    <input
                            *ngIf="adult.type === 'adult'"
                             #emailInput
                              name="email_{{i}}"
                              id="email_{{i}}"
                              autocomplete="off"
                              autocomplete="new-password"
                              aria-autocomplete="none"
                              (focus)="disableBraveAutofill(emailInput)"
                            id="email"
                            name="email"
                            class="form-control"
                            [ngClass]="{
                                        'is-invalid':
                                                      i< 1 && !_form.get('paxes').get(i.toString()).get('email').valid,
                                        'is-valid':
                                                    i<1 && _form.get('paxes').get(i.toString()).get('email').valid
                                      }"
                            [ngStyle]="getStyles(i)"
                            (input)="normalizeEmail($event.target.value, i);verifyExistWithDebounce($event.target.value, 'email', i); "
                            type="email"
                            formControlName="email"
                            aria-label="email"
                            aria-required="true"
                            autocapitalize="none"
                            placeholder="Email"
                            required
                    />
                    <input
                          *ngIf="adult.type === 'children'"
                           #emailInput
                              name="email_{{i}}"
                              id="email_{{i}}"
                              autocomplete="off"
                              autocomplete="new-password"
                              aria-autocomplete="none"
                              (focus)="disableBraveAutofill(emailInput)"
                          id="email"
                          name="email"
                          #email_children
                          class="form-control"
                          [ngStyle]="getStyles(i)"
                          (input)="normalizeEmail($event.target.value, i);verifyExistWithDebounce($event.target.value, 'email', i)"
                          type="email"
                          formControlName="email"
                          aria-label="email"
                          aria-required="true"
                          autocapitalize="none"
                          placeholder="Email"
                  />
                  </div>
                  <span
                  *ngIf="_form.get('paxes.' + i + '.email').errors && _form.get('paxes.' + i + '.email').errors.customErrorKey"
                  style="font-size: 14px; color: #e93a55; position: absolute; bottom: -6px; left: 20px;"
                  >Este email ya fue registrado</span
                  >
                  <span style="font-size: 14px; color: #e93a55; position: absolute; bottom: -8px; left: 10px;" *ngIf="_form.get('paxes').get(i.toString()).get('email').errors?.email">Formato invalido</span>
                </div>

              </ng-container>


              <ng-container *ngIf="i == 0 && (clientData.type === 'adult' && clientData.clientAssociated === true)">
                <div class="col-3 sm-gutters">
                  <div class="form-group">
                    <label class="font-weight-bold font-poppins"
                           style="font-size: small"
                           for="birth_date"
                      >Fecha de nacimiento <sup class="required-marker"> * </sup></label
                    >
                    <input
                          *ngIf="adult.type == 'adult'"
                          id="birth_date"
                          name="birth_date"
                          class="form-control"
                          [ngClass]="{
                                      'is-invalid': _form.value.paxes[i].birth_date == null,
                                      'is-valid':_form.value.paxes[i].birth_date != null
                                    }"
                          [ngStyle]="getStyles(i)"
                          type="text"
                          formControlName="birth_date"
                          aria-label="birth_date"
                          bsDatepicker
                          readonly
                          [maxDate]="formPaxesReservationData.minDateAdult"
                          [minDate]="formPaxesReservationData.maxDateAdult"
                          [bsConfig]="dpConfig"
                          autocomplete="off"
                          placeholder="Fecha de Nacimiento"
                    />
                    <input
                          *ngIf="adult.type == 'children'"
                          id="birth_date"
                          name="birth_date"
                          class="form-control"
                          [ngClass]="{
                                      'is-invalid': _form.value.paxes[i].birth_date == null,
                                      'is-valid':_form.value.paxes[i].birth_date != null
                                    }"
                          [ngStyle]="getStyles(i)"
                          type="text"
                          formControlName="birth_date"
                          aria-label="birth_date"
                          bsDatepicker
                          readonly
                        [minDate]="getChildMinDate(paxes[i]?.age, paxes[i]?.arrivalDate, paxes[i]?.arrivalDateString)"
[maxDate]="getChildMaxDate(paxes[i]?.age, paxes[i]?.arrivalDate, paxes[i]?.arrivalDateString)"
                          [bsConfig]="dpConfig"
                          autocomplete="off"
                          placeholder="Fecha de Nacimiento"
                    />
                    <small *ngIf="adult.type == 'children'" class="form-text text-muted" style="font-size: 11px; margin-top: 4px;">
  Seleccione día y mes. El año será {{_form.get(['paxes', i, 'birth_date'])?.value | date: 'yyyy'}} según la edad del niño.
</small>
                  </div>
                </div>
                <div class="col-5 sm-gutters adjust-input-document">
                  <div class="form-group position-relative">
                    <label class="font-weight-bold font-poppins"
                           for="document_type_id"
                           style="font-size: small"
                    >Tipo y N° documento <sup class="required-marker"> * </sup>
                    </label>
                    <div class="row d-flex ml-0 position-relative "
                         style="margin-right: -10px;">
                      <select
                              id="document_type_id"
                              #document_type_id
                              name="document_type_id"
                              class="form-control-sm custom-select "
                              style="width: 46%"
                              [ngClass]="{
                                          'is-invalid': _form.value.paxes[i].document_type_id == null,
                                          'is-valid':_form.value.paxes[i].document_type_id != null
                                        }"
                              [ngStyle]="getStyles(i)"
                              formControlName="document_type_id"
                              arial-label="document_type_id"
                              aria-required="true"
                              required
                              (change)="verifyExistWithDebounce($event.target.value, 'type_document', i)"
                      >
                        <!-- <option value="null" selected disabled>Tipo Doc</option> -->
                        <option value="null" selected disabled>Tipo Doc</option>
                        <ng-container *ngFor="let document of formPaxesReservationData.documentTypes">
                          <option [value]="document.id">{{document.name}}</option>
                        </ng-container>
                        <!-- <option value="4">DNI</option>
                        <option value="5">PASAPORTE</option> -->
                      </select>
                      <input
                        id="document_input_emit"
                        name="document_input_emit"
                        #document_number
                        class="form-control"
                        style="width: 50%; margin-left: 7px"
                        [ngClass]="{
                                    'is-invalid': _form.value.paxes[i].document_number == null ||
                                                  _form.value.paxes[i].document_number == '' ||
                                                  (_form.get('paxes.' + i + '.document_number').errors &&
                                                  _form.get('paxes.' + i + '.document_number').errors.customErrorKey) ||
                                                  (_form.get('paxes.' + i + '.document_number').errors && _form.get('paxes.' + i + '.document_number').errors.duplicateErrorKey) ,
                                    'is-valid': _form.value.paxes[i].document_number !== null ||
                                               _form.value.paxes[i].document_number !== null ||
                                               _form.get('paxes.' + i + '.document_number').valid
                                    }"
                        [ngStyle]="getStyles(i)"
                        type="text"
                        formControlName="document_number"
                        aria-label="document_input_emit"
                        aria-required="document_input_emit"
                        autocapitalize="none"
                        autocomplete="random-string"
                        min="0"
                        required
                        placeholder="N° documento"
                        (keydown)="onDocumentKeyDown($event, i)"
                        (input)=" verifyExistWithDebounce($event.target.value, 'document_number', i)"
                      />
                      <span
                           *ngIf="_form.get('paxes.' + i + '.document_number').errors && _form.get('paxes.' + i + '.document_number').errors.customErrorKey"
                            class="position-absolute"
                            style="font-size: 14px; color: #e93a55; position: absolute; bottom: -20px; left: 10px;"
                      >
                            Este número ya fue registrado</span
                      >
                      <span
                      *ngIf="_form.get('paxes.' + i + '.document_number').errors && _form.get('paxes.' + i + '.document_number').errors.duplicateErrorKey"
                      style="font-size: 14px; color: #e93a55; position: absolute; bottom: -24px; left: 20px;"
                      >Duplicado en formularios</span>
                      <span
                          style="font-size: 14px; color: #e93a55; position: absolute; bottom: -24px; left: 10px;"
                          *ngIf="_form.get(['paxes', i, 'document_number'])?.hasError('nonNegative') || _form.get(['paxes', i, 'document_number'])?.hasError('pattern') &&
                          (_form.get('paxes.' + i + '.document_type_id').value === '4' || _form.get('paxes.' + i + '.document_type_id').value === 4)"
                        >
                             Ingresar números. No puede ser negativo
                      </span>
                    </div>
                  </div>
                </div>

                <div class="col-4 sm-gutters" style="position: relative;">
                  <div class="form-group">
                    <label class="font-weight-bold font-poppins"
                           for="email"
                           style="font-size: small"
                      >Email <sup class="required-marker"> * </sup></label
                    >
                    <input
                          id="email"
                          name="email"
                          class="form-control"
                          [ngClass]="{
                                      'is-invalid': !_form.get('paxes').get(i.toString()).get('email').valid,
                                      'is-valid': _form.get('paxes').get(i.toString()).get('email').valid
                                    }"
                          [ngStyle]="getStyles(i)"
                          type="email"
                          formControlName="email"
                          aria-label="email"
                          aria-required="true"
                          aria-autocomplete="none"
                          autocapitalize="none"
                          autocomplete="random-string"
                          placeholder="Email"
                          required
                          (input)="onChangeParentData($event.target.value, 'email');normalizeEmail($event.target.value, i); verifyExistWithDebounce($event.target.value, 'email', i)"
                    />
                  </div>
                    <span
                    *ngIf="_form.get('paxes.' + i + '.email').errors && _form.get('paxes.' + i + '.email').errors.customErrorKey"
                    style="font-size: 14px; color: #e93a55; position: absolute; bottom: -6px; left: 20px;"
                    >Este email ya fue registrado</span
                    >
                  <span style="font-size: 14px; color: #e93a55; position: absolute; bottom: -8px; left: 10px;" *ngIf="_form.get('paxes').get(i.toString()).get('email').errors?.email">Formato invalido</span>
                </div>
              </ng-container>
            </div>

<!--
    CLIENTE O PASAJERO === 1
      select país
-->
            <div class="row"
                  style="margin-top: 40px"
                  [ngStyle]="{'margin-top': data.typeAction ? '10px' : '40px'}">
              <ng-container *ngIf="i == 0">
                <div class="col-4 sm-gutters" style="position: relative">
                  <div

                        class="form-group position-relative">
                    <label
                          class="font-weight-bold font-poppins"
                          for="country_id"
                          style="font-size: small"
                      >País <sup class="required-marker"> * </sup></label
                    >

                    <div *ngIf="countryCheck[i] && !selectedClientAssociated" class="selected-country">
                      <input class="chip"
                             formControlName="country_id"
                             [ngStyle]="getStyles(i, 'country')"
                             value="{{ _form.get('paxes').value[i].country_id }}"
                             readonly>

                        <button
                                type="button"
                                class="close-chip"
                                tooltip="Eliminar País"
                                placement="bottom"
                                (click)="clearCountry(i, 'country')">
                          ×
                        </button>
                    </div>
                    <input *ngIf="!countryCheck[i] || selectedClientAssociated"
                            #countryInput
                            name="country_id_{{i}}"
                            id="country_id_{{i}}"
                            autocomplete="off"
                            autocomplete="new-password"
                            aria-autocomplete="none"
                            (focus)="disableBraveAutofill(countryInput)"
                            class="form-control"
                            [ngClass]="{
                                        'is-invalid': !countryCheck[i],
                                        'is-valid': countryCheck[i]
                                       }"
                            [ngStyle]="getStyles(i, 'country')"
                            type="text"
                            [(ngModel)]="selectedIsCountry[i]"
                            formControlName="country_id"
                            aria-label="country_id"
                            aria-required="true"
                            typeaheadOptionField="country_name"
                            [typeahead]="filteredCountries"
                            placeholder="Escriba para buscar país..."
                            autocapitalize="none"
                            (typeaheadOnSelect)="
                                                getStatesData(i);
                                                onChangeParentData($event, 'country')
                                               "
                           required
                      >
                  </div>
                  <span
                  *ngIf="_form.get('paxes.' + i + '.country_id').touched && !countryCheck[i]"
                  style="font-size: 14px; color: #e93a55; position: absolute; bottom: -6px; left: 20px;"
                  >Escriba y seleccione un país</span
                  >
                </div>
              </ng-container>


<!--
    CLIENTE O PASAJERO MAYOR A 1
        select país
-->
              <ng-container *ngIf="i > 0 && editDataPax[i]">
                <div class="col-4 sm-gutters"
                      style="position: relative"
                      >
                  <div class="form-group position-relative" >
                    <label class="font-weight-bold font-poppins"
                            for="country_id"
                            style="font-size: small"
                      >País <span *ngIf="i < 1 && adult.type !=='children'"><sup class="required-marker" > * </sup></span></label
                      >
                      <div *ngIf="countryCheck[i] && !selectedClientAssociated" class="selected-country">
                        <input class="chip"
                               formControlName="country_id"
                               [ngStyle]=" getStyles(i, 'country')"
                               value="{{ adult.type === 'adult' ? _form.get('paxes').value[i].country_id : formPaxesReservationData?.country_parent}}"
                               readonly>

                          <button
                                  type="button"
                                  class="close-chip"
                                  tooltip="Eliminar País"
                                  placement="bottom"
                                  (click)="clearCountry(i, 'country')">
                            ×
                          </button>
                      </div>
                      <ng-container *ngIf="adult.type === 'adult'">
                        <input *ngIf="!countryCheck[i] || selectedClientAssociated"
                            #countryInput
                            name="country_id_{{i}}"
                            id="country_id_{{i}}"
                            autocomplete="off"
                            autocomplete="new-password"
                            aria-autocomplete="none"
                            (focus)="disableBraveAutofill(countryInput)"
                            id="country_id"
                            name="country_id"
                            class="form-control"
                                  [ngClass]="{
                                          'is-invalid': i<1 && !countryCheck[i],
                                          'is-valid': i<1 && countryCheck[i]
                                        }"
                            [ngStyle]="getStyles(i)"
                          type="text"
                          [(ngModel)]="selectedIsCountry[i]"
                          formControlName="country_id"
                          aria-label="country_id"
                          aria-required="true"
                          typeaheadOptionField="country_name"
                          [typeahead]="filteredCountries"
                          placeholder="Escriba para buscar país..."
                          autocapitalize="none"
                          (typeaheadOnSelect)="getStatesData(i)"
                          required
                      >
                      </ng-container>
                      <ng-container  *ngIf="adult.type === 'children' && editDataPax[i]">
                        <input *ngIf="!countryCheck[i] || selectedClientAssociated"
                               #countryInput
                              name="country_id_{{i}}"
                              id="country_id_{{i}}"
                              autocomplete="off"
                              autocomplete="new-password"
                              aria-autocomplete="none"
                              (focus)="disableBraveAutofill(countryInput)"
                              class="form-control"
                              #countryChild
                              [ngStyle]="getStyles(i)"
                              type="text"
                              [(ngModel)]="formPaxesReservationData?.country_parent ? formPaxesReservationData?.country_parent : selectedIsCountry[0]"
                              formControlName="country_id"
                              aria-label="country_id"
                              aria-required="true"
                              typeaheadOptionField="country_name"
                              [typeahead]="filteredCountries"
                              placeholder="Escriba para buscar país..."
                              autocapitalize="none"
                              (typeaheadOnSelect)="
                                                  getStatesData(i);
                                                "
                      >
                    </ng-container>
                  </div>
                  <span
                  *ngIf="_form.get('paxes.' + i + '.country_id').touched && !countryCheck[i]"
                  style="font-size: 14px; color: #e93a55; position: absolute; bottom: -6px; left: 20px;"
                  >Escriba y seleccione un país</span
                  >
                </div>
              </ng-container>

<!--
    CLIENTE O PASAJERO === 1
      select provincia

-->

              <div class="col-8 sm-gutters">
                <ng-container *ngIf="i == 0">
                  <div class="form-group" style="position: relative">
                    <label class="font-weight-bold font-poppins"
                            for="state_id"
                            style="font-size: small"
                      >Región <span *ngIf="i < 1 && adult.type !=='children'"><sup class="required-marker" > * </sup></span></label
                    >
                    <div *ngIf="stateCheck[i] && !selectedClientAssociated" class="selected-country">
                      <input class="chip"
                             formControlName="state_id"
                             [ngStyle]="getStyles(i)"
                             value="{{ _form.get('paxes').value[i].state_id }}"
                             readonly>

                        <button type="button"
                                class="close-chip"
                                tooltip="Eliminar Región"
                                placement="bottom"
                                (click)="clearCountry(i, 'state')">
                          ×
                        </button>
                    </div>
                      <input *ngIf="!stateCheck[i] || selectedClientAssociated"
                       #stateInput
                            name="state_id_{{i}}"
                            id="state_id_{{i}}"
                            autocomplete="off"
                            autocomplete="new-password"
                            aria-autocomplete="none"
                            (focus)="disableBraveAutofill(stateInput)"
                              id="state_id"
                              name="state_id"
                              class="form-control"
                              [ngStyle]="getStyles(i)"
                              type="text"
                              [(ngModel)]="selectedIsState[i]"
                              formControlName="state_id"
                              aria-label="state_id"
                              aria-required="true"
                              typeaheadOptionField="destination_name"
                              [typeahead]="data.typeAction ? clientData?.states : formPaxesReservationData?.states[i]?.states "
                              placeholder="Escriba para buscar región..."
                              autocapitalize="none"
                              (typeaheadOnSelect)="getCitiesData(i);
                                                   onChangeParentData($event, 'destination')"
                    >
                    <span
                    *ngIf="_form.get('paxes.' + i + '.state_id').touched && _form.get('paxes.' + i + '.country_id')?.valid && !stateCheck[i]"
                    style="font-size: 14px; color: #e93a55; position: absolute; bottom: -22px; left: 20px;"
                    >Escriba y luego seleccione una región de la lista desplegable</span
                    >
                    <span
                    *ngIf="_form.get('paxes.' + i + '.state_id').touched && _form.get('paxes.' + i + '.country_id')?.invalid && !stateCheck[i]"
                    style="font-size: 14px; color: #e93a55; position: absolute; bottom: -22px; left: 20px;"
                    >Escriba y luego seleccione un país</span
                    >
                  </div>
                </ng-container>



<!--
    CLIENTE O PASAJERO MAYOR A 1
        select provincia
-->

                <ng-container *ngIf="i > 0 && editDataPax[i]">
                  <div class="form-group"
                        style="position: relative"
                  >

                  <label class="font-weight-bold font-poppins"
                  for="state_id"
                              style="font-size: small"
                        >Región <span *ngIf="i < 1 && adult.type !=='children'"></span></label
                      >
                      <div *ngIf="stateCheck[i] && !selectedClientAssociated && adult.type === 'adult'" class="selected-country">
                        <input class="chip"
                               formControlName="state_id"
                               [ngStyle]="getStyles(i)"
                               value="{{ _form.get('paxes').value[i].state_id }}"
                               readonly>

                          <button type="button"
                                  class="close-chip"
                                  tooltip="Eliminar Región"
                                  placement="bottom"
                                  (click)="clearCountry(i, 'state')">
                            ×
                          </button>
                      </div>
                      <div *ngIf="stateCheck[i] && !selectedClientAssociated && adult.type === 'children' && editDataPax[i]" class="selected-country">
                        <input class="chip"
                               formControlName="state_id"
                               [ngStyle]="getStyles(i)"
                               value="{{ selectedIsState[i] }}"
                               readonly>

                          <button type="button"
                                  class="close-chip"
                                  tooltip="Eliminar Región"
                                  placement="bottom"
                                  (click)="clearCountry(i, 'state')">
                            ×
                          </button>
                      </div>
                        <input *ngIf="adult.type === 'adult' && (!stateCheck[i] || selectedClientAssociated)"
                                 #stateIdInput
                              name="state_id_{{i}}"
                              id="state_id_{{i}}"
                              autocomplete="off"
                              autocomplete="new-password"
                              aria-autocomplete="none"
                              (focus)="disableBraveAutofill(stateIdInput)"
                                class="form-control"
                                   [ngClass]="{
                                              'is-invalid':i<1 &&  !stateCheck[i],
                                              'is-valid': i<1 &&  stateCheck[i]
                                            }"
                                [ngStyle]="getStyles(i)"
                                type="text"
                                [(ngModel)]="selectedIsState[i]"
                                formControlName="state_id"
                                aria-label="state_id"
                                aria-required="true"
                                typeaheadOptionField="destination_name"
                                [typeahead]="formPaxesReservationData?.states[i]?.states"
                                placeholder="Escriba para buscar región..."
                                autocapitalize="none"
                                (typeaheadOnSelect)="getCitiesData(i);"
                        >

                      <input  *ngIf="adult.type === 'children' && (!stateCheck[i] || selectedClientAssociated) && editDataPax[i]"
                                 #stateIdInput
                              name="state_id_{{i}}"
                              id="state_id_{{i}}"
                              autocomplete="off"
                              autocomplete="new-password"
                              aria-autocomplete="none"
                              (focus)="disableBraveAutofill(stateIdInput)"
                                class="form-control"
                                          [ngStyle]="getStyles(i)"
                                type="text"
                                [(ngModel)]="this.formPaxesReservationData?.state_parent ? this.formPaxesReservationData?.state_parent: selectedIsState[i]"
                                formControlName="state_id"
                                aria-label="state_id"
                                aria-required="true"
                                typeaheadOptionField="destination_name"
                                [typeahead]="formPaxesReservationData?.states[i]?.states"
                                placeholder="Escriba para buscar región..."
                                autocapitalize="none"
                                (typeaheadOnSelect)="getCitiesData(i);"
                        >
                    <span
                        *ngIf="_form.get('paxes.' + i + '.state_id').touched && _form.get('paxes.' + i + '.country_id')?.valid && !stateCheck[i]"
                        style="font-size: 14px; color: #e93a55; position: absolute; bottom: -22px; left: 20px;"
                        >Escriba y luego seleccione una región de la lista</span
                        >
                    <span
                        *ngIf="_form.get('paxes.' + i + '.state_id').touched && _form.get('paxes.' + i + '.country_id')?.invalid && !stateCheck[i]"
                        style="font-size: 14px; color: #e93a55; position: absolute; bottom: -22px; left: 20px;"
                        >Escriba y luego seleccione un país</span
                    >
                  </div>
                </ng-container>
              </div>
        </div>




<!--
    CLIENTE O PASAJERO === 1
      input dirección
-->




            <div class="row"
                  style="margin-top: 40px"
                  [ngStyle]="{'margin-top': data.typeAction ? '10px' : '40px'}">

                  <!--
    CLIENTE O PASAJERO === 1
      input ciudad
-->


              <ng-container *ngIf="i == 0">
                <div class="col-5 sm-gutters" style="position: relative">
                  <div class="form-group">
                    <label class="font-weight-bold font-poppins"
                            for="city"
                            style="font-size: small"
                      >Ciudad </label
                    >
                    <div *ngIf="cityCheck[i] && !selectedClientAssociated" class="selected-country">
                      <input class="chip"
                             formControlName="city"
                             [ngStyle]="getStyles(i)"
                             value="{{ _form.get('paxes').value[i].city }}"
                             readonly>

                        <button type="button"
                                class="close-chip"
                                tooltip="Eliminar Ciudad"
                                placement="bottom"
                                (click)="clearCountry(i, 'city')">
                          ×
                        </button>
                    </div>
                    <input  *ngIf="!cityCheck[i] || selectedClientAssociated"
                            #cityInput
                              name="city_{{i}}"
                              id="city_{{i}}"
                              autocomplete="off"
                              autocomplete="new-password"
                              aria-autocomplete="none"
                            class="form-control"
                            [ngStyle]="getStyles(i)"
                           type="text"
                           [(ngModel)]="selectedIsCity[i]"
                           formControlName="city"
                           aria-label="city"
                           aria-required="true"
                           typeaheadOptionField="city_name"
                           [typeahead]="data.typeAction ? citiesFiltered :  formPaxesReservationData?.cities[i]?.cities"
                           placeholder="Escriba para buscar ciudad..."
                           autocapitalize="none"
                           (typeaheadOnSelect)="
                           changeCity(i);
                           onChangeParentData($event, 'city')"
                      >
                  </div>
                  <span
                        *ngIf="_form.get('paxes.' + i + '.city').touched &&
                                countryCheck[i] &&
                                !stateCheck[i] &&
                                !cityCheck[i]"
                        style="font-size: 14px; color: #e93a55; position: absolute; bottom: -6px; left: 20px;"
                        >Escriba y luego seleccione una región</span
                        >
                  <span
                        *ngIf="_form.get('paxes.' + i + '.city').touched &&
                                !countryCheck[i] &&
                                !stateCheck[i] &&
                                !cityCheck[i]"
                        style="font-size: 14px; color: #e93a55; position: absolute; bottom: -6px; left: 20px;"
                        >Escriba y luego seleccione un país</span
                    >
                    <span
                        *ngIf="_form.get('paxes.' + i + '.city').touched &&
                                 countryCheck[i] &&
                                 stateCheck[i] &&
                                !cityCheck[i]"
                        style="font-size: 14px; color: #e93a55; position: absolute; bottom: -6px; left: 20px;"
                        >Escriba y luego seleccione una ciudad</span
                        >
                </div>
              </ng-container>


<!--
    CLIENTE O PASAJERO MAYOR A 1
        input ciudad
-->

              <ng-container *ngIf="i > 0 && editDataPax[i]">
                <div class="col-5 sm-gutters" style="position: relative">
                  <div class="form-group">
                    <label class="font-weight-bold font-poppins"
                            for="city"
                            style="font-size: small"
                      >Ciudad <span *ngIf="i < 1 && adult.type !=='children'"></span></label
                    >
                    <div *ngIf="cityCheck[i] && !selectedClientAssociated" class="selected-country">
                      <input class="chip"
                             formControlName="city"
                             [ngStyle]="getStyles(i)"
                             value="{{ selectedIsCity[i] }}"
                             readonly>

                        <button type="button"
                                class="close-chip"
                                tooltip="Eliminar Ciudad"
                                placement="bottom"
                                (click)="clearCountry(i, 'city')">
                          ×
                        </button>
                    </div>
                    <ng-container *ngIf="!cityCheck[i] || selectedClientAssociated">


                      <input
                            *ngIf="adult.type === 'adult'"
                             #nameInput
                              name="city_{{i}}"
                              id="city_{{i}}"
                              autocomplete="off"
                              autocomplete="new-password"
                              aria-autocomplete="none"
                            class="form-control"
                            [ngStyle]="getStyles(i)"
                          type="text"
                          [(ngModel)]="selectedIsCity[i]"
                          formControlName="city"
                          aria-label="city"
                          aria-required="true"
                          typeaheadOptionField="city_name"
                          [typeahead]="formPaxesReservationData?.cities[i]?.cities"
                           placeholder="Escriba para buscar ciudad..."
                          autocapitalize="none"
                          (typeaheadOnSelect)="changeCity(i)"
                      >
                      <input
                            *ngIf="adult.type === 'children' && editDataPax[i]"
                             #cityInput
                              name="city_{{i}}"
                              id="city_{{i}}"
                              autocomplete="off"
                              autocomplete="new-password"
                              aria-autocomplete="none"
                            class="form-control"
                            [ngStyle]="getStyles(i)"
                          type="text"
                          [(ngModel)]="this.formPaxesReservationData?.city_parent ? this.formPaxesReservationData?.city_parent : selectedIsCity[i]"
                          formControlName="city"
                          aria-label="city"
                          aria-required="true"
                          typeaheadOptionField="city_name"
                          [typeahead]="formPaxesReservationData?.cities[i]?.cities"
                           placeholder="Escriba para buscar ciudad..."
                          autocapitalize="none"
                          (typeaheadOnSelect)="changeCity(i)"
                      >
                    </ng-container>
                    </div>
                    <span
                        *ngIf="_form.get('paxes.' + i + '.city').touched &&
                                countryCheck[i] &&
                                !stateCheck[i] &&
                                !cityCheck[i]"
                        style="font-size: 14px; color: #e93a55; position: absolute; bottom: -6px; left: 20px;"
                        >Escriba y luego seleccione una región</span
                        >
                  <span
                        *ngIf="_form.get('paxes.' + i + '.city').touched &&
                                !countryCheck[i] &&
                                !stateCheck[i] &&
                                !cityCheck[i]"
                        style="font-size: 14px; color: #e93a55; position: absolute; bottom: -6px; left: 20px;"
                        >Escriba y luego seleccione un país</span
                    >
                    <span
                        *ngIf="_form.get('paxes.' + i + '.city').touched &&
                                 countryCheck[i] &&
                                 stateCheck[i] &&
                                !cityCheck[i]"
                        style="font-size: 14px; color: #e93a55; position: absolute; bottom: -6px; left: 20px;"
                        >Escriba y luego seleccione una ciudad</span
                        >
                  </div>
                </ng-container>

                <div class=" col-7">
                    <ng-container *ngIf="i == 0">
                      <div class="row" style="position: relative">
                        <div class="col-12 sm-gutters">
                          <div class="form-group">
                            <label class="font-weight-bold font-poppins"
                                   for="address"
                                   style="font-size: small"
                              >Dirección</label
                            >
                            <input
                                    #addressInput
                              name="address_{{i}}"
                              id="address_{{i}}"
                              autocomplete="off"
                              autocomplete="new-password"
                              aria-autocomplete="none"
                              (focus)="disableBraveAutofill(addressInput)"
                                    class="form-control"
                                              [ngStyle]="getStyles(i)"
                                    type="text"
                                    formControlName="address"
                                    aria-label="address"
                                    (keydown)="blockInvalidKeys($event, 'address')"
                                    aria-required="true"
                                    autocapitalize="none"
                                    [minLength]="5"
                                    placeholder="Dirección"
                                    (input)="onChangeParentData($event.target.value, 'address')"
                            />
                          </div>
                        </div>
                        <span
                        style="font-size: 14px; color: #e93a55; position: absolute; bottom: -6px; left: 20px;"
                        *ngIf="_form.get(['paxes', i, 'address'])?.hasError('minlength')"
                      >
                        Mínimo 5 caracteres
                      </span>
                      </div>
                    </ng-container>
    <!--
        CLIENTE O PASAJERO === 1
          input dirección
    -->

                    <ng-container *ngIf="i > 0 && editDataPax[i]">
                      <div class="row" style="position: relative;">
                        <div class="col-12 sm-gutters">
                          <div class="form-group">
                            <label class="font-weight-bold font-poppins"
                                    for="address"
                                    style="font-size: small"
                              >Dirección <span *ngIf="i < 1 && adult.type !=='children'"></span>
                              </label
                            >
                            <input
                                  *ngIf="adult.type === 'adult'"
                                  #addressInput
                                  name="address_{{i}}"
                                  id="address_{{i}}"
                                  autocomplete="off"
                                  autocomplete="new-password"
                                  aria-autocomplete="none"
                                  (focus)="disableBraveAutofill(addressInput)"
                                  class="form-control"
                                  [ngStyle]="getStyles(i)"
                                  type="text"
                                  formControlName="address"
                                  aria-label="adress"
                                  [minLength]="5"
                                  aria-required="true"
                                    (keydown)="blockInvalidKeys($event, 'address')"
                                  autocapitalize="none"
                                  placeholder="Dirección"
                            />
                            <input
                                  *ngIf="adult.type === 'children' && editDataPax[i]"
                                  id="address_children"
                                  #address_children
                                  name="address_{{i}}"
                                  autocomplete="off"
                                  autocomplete="new-password"
                                  aria-autocomplete="none"
                                  (focus)="disableBraveAutofill(address_children)"
                                  class="form-control"
                                  [ngStyle]="getStyles(i)"
                                  [minLength]="5"
                                  type="text"
                                  formControlName="address"
                                  (keydown)="blockInvalidKeys($event, 'address')"
                                  aria-label="adress"
                                  aria-required="true"
                                  autocapitalize="none"
                                  placeholder="Dirección"
                            />
                          </div>
                        </div>
                        <span
                        style="font-size: 14px; color: #e93a55; position: absolute; bottom: -6px; left: 20px;"
                        *ngIf="_form.get(['paxes', i, 'address'])?.hasError('minlength')"
                      >
                        Mínimo 5 caracteres
                      </span>
                      </div>
                    </ng-container>
                  </div>
                </div>



<!--

    CLIENTE O PASAJERO TELEFONO OBLIGATORIO Y OPCIONAL

-->

            <div class="row"
                  style="margin-top: 40px;"
                  [ngStyle]="{'margin-top': data.typeAction ? '10px' : '40px'}"
            >

              <div class="col-6 sm-gutters">
                <div class="form-group"
                     [ngStyle]="{
                                  'margin-bottom': data.typeAction === 'New' &&
                                  clientData.fromAssociates === true ? '0' : '15px'
                                }"
                >
                  <label *ngIf="i === 0" class="font-weight-bold font-poppins"
                         for="phone"
                         style="font-size: small;"
                  >Cod + Telefono <sup class="required-marker"> * </sup></label>

                  <label *ngIf="i > 0 && editDataPax[i]" class="font-weight-bold font-poppins"
                         for="phone"
                         style="font-size: small;"
                  >Cod + Telefono <span *ngIf="i < 1 && adult.type !=='children'"><sup class="required-marker" > * </sup></span></label>

                  <div class="row" style="position: relative;">

                    <div *ngIf="i === 0" class="col-7"  style="padding-right: 4px;">
                      <div class="form-group" style="position:relative"
                            >
                            <div *ngIf="phoneCodeCheck[i] && !selectedClientAssociated" class="selected-country">
                              <input class="chip"
                                     [ngStyle]="getStyles(i, 'phone_code')"
                                     value="{{ _form.get('paxes').value[i].phone_code }}"
                                     readonly>

                                <button
                                        type="button"
                                        class="close-chip"
                                        tooltip="Eliminar Código telefónico"
                                        placement="bottom"
                                        (click)="clearCountry(i, 'phone_code')">
                                  ×
                                </button>
                            </div>
                            <ng-container *ngIf="!phoneCodeCheck[i] || selectedClientAssociated">
                              <input
                              #phoneCode
                              class="form-control"
                              name="phone_code_{{i}}"
                              id="phone_code_{{i}}"
                              autocomplete="off"
                              autocomplete="new-password"
                              aria-autocomplete="none"
                              [ngClass]="{
                                'is-invalid': !phoneCodeCheck[i],
                                'is-valid': phoneCodeCheck[i]
                              }"
                              [ngStyle]="getStyles(i, 'phone')"
                              type="text"
                              [(ngModel)]="phone_code[i]"
                              formControlName="phone_code"
                              (blur)="onPhoneBlur(i)"
                              aria-label="phone_code"
                              aria-required="true"
                              typeaheadOptionField="displayValue"
                              [typeahead]="filteredCountries"
                              placeholder="País + cód. telefónico"
                              (typeaheadOnSelect)="onChangeParentData($event, 'phone_code'); changePhoneCode(i, $event.item.country_code, 'phone_code')"
                              autocapitalize="none"
                              required
                        >
                            </ng-container>
                            <span
                                  *ngIf="_form.get('paxes.' + i + '.phone_code').touched && !phoneCodeCheck[i]"
                                  style="font-size: 14px; color: #e93a55; position: absolute; bottom: -24px; left: 20px;"
                                  >Seleccione un código</span
                                  >
                            </div>
                    </div>
                    <div *ngIf="i > 0 && editDataPax[i]" class="col-7"  style="padding-right: 4px;">
                      <div class="form-group"
                      >
                        <div *ngIf="phoneCodeCheck[i] && !selectedClientAssociated && adult.type === 'children' && editDataPax[i]" class="selected-country">
                          <input class="chip"
                                [ngStyle]="getStyles(i, 'phone_code')"
                                value="{{ this.formPaxesReservationData.phone_code_parent ? this.formPaxesReservationData.phone_code_parent : phone_code[i] }}"
                                readonly>

                            <button *ngIf="!productTransferInItinerary(i)"
                                    type="button"
                                    class="close-chip"
                                    tooltip="Eliminar Código telefónico"
                                    placement="bottom"
                                    (click)="clearCountry(i, 'phone_code')">
                              ×
                            </button>
                        </div>
                        <div *ngIf="phoneCodeCheck[i] && !selectedClientAssociated && adult.type === 'adult'" class="selected-country">
                          <input class="chip"
                                [ngStyle]="getStyles(i, 'phone_code')"
                                value="{{ _form.get('paxes').value[i].phone_code }}"
                                readonly>

                            <button *ngIf="!productTransferInItinerary(i)"
                                    type="button"
                                    class="close-chip"
                                    tooltip="Eliminar Código telefónico"
                                    placement="bottom"
                                    (click)="clearCountry(i, 'phone_code')">
                              ×
                            </button>
                        </div>
                      <ng-container *ngIf="!phoneCodeCheck[i] || selectedClientAssociated">
                        <input
                              *ngIf="formPaxesReservationData.countries && adult.type === 'children' && editDataPax[i]"

                              #phoneCodeInput
                              name="phone_code_{{i}}"
                              id="phone_code_{{i}}"
                              autocomplete="off"
                              autocomplete="new-password"
                              aria-autocomplete="none"
                              (focus)="disableBraveAutofill(phoneCodeInput)"
                              class="form-control"
                              [ngStyle]="getStyles(i, 'phone_code')"
                              type="text"
                              [(ngModel)]="this.formPaxesReservationData.phone_code_parent ? this.formPaxesReservationData.phone_code_parent : phone_code[i]"
                              formControlName="phone_code"
                              aria-label="phone_code"
                              aria-required="true"
                              typeaheadOptionField="displayValue"
                              [typeahead]="filteredCountries"
                              placeholder="País + cód. telefónico"
                              (typeaheadOnSelect)="changePhoneCode(i, $event.item.country_code,'phone_code')"
                              autocapitalize="none"
                        >
                        <input
                              *ngIf="formPaxesReservationData.countries && adult.type === 'adult' && editDataPax[i]"
                              id="phone_code"
                              #phoneChildren
                              name="phone_code_{{i}}"
                              id="phone_code_{{i}}"
                              autocomplete="off"
                              autocomplete="new-password"
                              aria-autocomplete="none"
                              (focus)="disableBraveAutofill(phoneChildren)"
                              name="phone_code"

                              class="form-control"
                              [ngClass]="{
                                'is-invalid':i<=1 &&  !phoneCodeCheck[i],
                                'is-valid': i<=1 && phoneCodeCheck[i]
                              }"
                              [ngStyle]="getStyles(i, 'phone_code')"
                              type="text"
                              [(ngModel)]="phone_code[i]"
                              formControlName="phone_code"
                              aria-label="phone_code"
                              aria-required="true"
                              (blur)="onPhoneBlur(i)"
                              typeaheadOptionField="displayValue"
                              [typeahead]="filteredCountries"
                              placeholder="País + cód. telefónico"
                              (typeaheadOnSelect)="changePhoneCode(i, $event.item.country_code,'phone_code')"
                              autocapitalize="none"
                              autocomplete="random-string"
                              required
                        >
                      </ng-container>
                      </div>

                    </div>
                    <div class="col-5"
                          style="padding-left: 4px;">
                      <input
                            *ngIf="adult.type === 'adult'  && editDataPax[i]"
                            id="phone"
                            name="phone"
                            (keydown)="blockInvalidKeys($event, 'phone')"
                            class="form-control"
                            [ngClass]="{
                                          'is-invalid': hasPhoneError(i),
                                          'is-valid': hasPhoneValid(i)
                                        }"
                            [ngStyle]="getStyles(i, 'phone')"
                            type="number"
                            formControlName="phone"
                            aria-label="phone"
                            aria-required="true"
                            autocapitalize="none"
                            autocomplete="random-string"
                            (blur)="onPhoneBlur(i)"
                            [maxLength]="15"
                            [minLength]="6"
                            placeholder="Phone"
                            required
                      />
                      <input
                            *ngIf="adult.type === 'children' && editDataPax[i]"
                            id="phone"
                            name="phone"
                            class="form-control"
                            (keydown)="blockInvalidKeys($event, 'phone')"
                            [ngStyle]="getStyles(i, 'phone')"
                            type="number"
                            formControlName="phone"
                            [ngClass]="{
                                        'is-invalid': productTransferInItinerary(i) &&
                                        (
                                                     _form.value.paxes[i].phone == null ||
                                                      _form.value.paxes[i].phone == '' ||
                                                      _form.get(['paxes', i, 'phone'])?.errors?.invalidPhone ||
                                                      _form.get(['paxes', i, 'phone'])?.errors?.pattern),
                                        'is-valid': productTransferInItinerary(i) &&
                                        (

                                                       (_form.value.paxes[i].phone !== null ||
                                                      _form.value.paxes[i].phone !== '') &&
                                                      !_form.get(['paxes', i, 'phone'])?.errors?.pattern &&
                                                    !_form.get(['paxes', i, 'phone'])?.errors?.invalidPhone)
                                      }"
                            aria-label="phone"
                            aria-required="true"
                            autocapitalize="none"
                            autocomplete="random-string"
                            [maxLength]="15"
                            [minLength]="6"
                            placeholder="Phone"
                      />
                    </div>
                    <span
                          style="font-size: 14px; color: #e93a55; position: absolute; bottom: -6px; left: 20px;"
                          *ngIf="_form.get(['paxes', i, 'phone'])?.errors?.pattern && !isPhoneValidating[i]">
                          Mínimo 6 caracteres y sin valores negativos
                    </span>
                   <span
                        style="font-size: 14px; color: #3498db; position: absolute; bottom: -6px; left: 20px;"
                        *ngIf="isPhoneValidating[i]">
                        Verificando número...
                    </span>

                    <span
                        style="font-size: 14px; color: #e93a55; position: absolute; bottom: -6px; left: 20px;"
                        *ngIf="_form.get(['paxes', i, 'phone'])?.errors?.invalidPhone && !isPhoneValidating[i]">
                        Número inválido
                    </span>
                  </div>
                </div>

              </div>

<!--

    select e input de código de país + telefono 2

-->


              <div *ngIf=" editDataPax[i]" class="col-6 sm-gutters">
                <div class="form-group"
                     [ngStyle]="{
                                 'margin-bottom': data.typeAction === 'New' &&
                                 clientData.fromAssociates === true ? '0' : '15px'
                               }"
                >
                  <label class="font-weight-bold font-poppins"
                         for="phone_2"
                         style="font-size: small;">Cod + Telefono 2</label>
                  <div class="row" style="position: relative;">
                            <div class="col-7" style="padding-right: 4px;">
                              <div class="form-group" style="position: relative">
                                <div *ngIf="phoneCode2Check[i] && !selectedClientAssociated" class="selected-country">
                                  <input class="chip"
                                         formControlName="phone_2_code"
                                         [ngStyle]="getStyles(i, 'phone_2_code')"
                                         value="{{ _form.get('paxes').value[i].phone_2_code }}"
                                         readonly>

                                    <button
                                            type="button"
                                            class="close-chip"
                                            tooltip="Eliminar Código telefónico"
                                            placement="bottom"
                                            (click)="clearCountry(i, 'phone_2_code')">
                                      ×
                                    </button>
                                </div>
                                <input *ngIf="!phoneCode2Check[i] || selectedClientAssociated"

                                      id="phone_2_code"
                                      name="phone_2_code"
                                      class="form-control"
                                      type="text"
                                      [(ngModel)]="phone_2_code[i]"
                                      formControlName="phone_2_code"
                                      aria-label="phone_2_code"
                                      aria-required="true"
                                      [ngStyle]="getStyles(i)"
                                      typeaheadOptionField="displayValue"
                                      [typeahead]="filteredCountries"
                                      (typeaheadOnSelect)="changePhoneCode(i, '', 'phone_2_code')"
                                      placeholder="País + cód. telefónico"
                                      autocapitalize="none"
                                      autocomplete="random-string"
                                >
                      </div>
                    </div>
                    <div class="col-5" style="padding-left: 4px;">
                      <input
                              id="phone_2"
                              name="phone_2"
                              class="form-control"
                              (keydown)="blockInvalidKeys($event, 'phone')"
                              [ngStyle]="getStyles(i)"
                              type="number"
                              formControlName="phone_2"
                              [maxLength]="15"
                              [minLength]="6"
                              aria-label="phone_2"
                              autocapitalize="none"
                              autocomplete="random-string"
                              placeholder="Phone 2"
                       />
                      </div>
                      <span
                         style="font-size: 14px; color: #e93a55; position: absolute; bottom: -6px; left: 20px;"
                         *ngIf="_form.get(['paxes', i, 'phone_2'])?.errors?.pattern">
                         Mínimo 6 caracteres y sin valores negativos
                      </span>
                  </div>
                </div>
              </div>

            </div>
            <span *ngIf="i === 0" class="required-marker">* Campos Obligatorios</span>
            <span *ngIf="i > 0 && editDataPax[i]" class="required-marker">* Campos Obligatorios</span>
            <div class="row">
              <div class="col-4" style="display: flex; gap: 15px;">
                <ng-container *ngIf="data.typeAction === 'New' && data.fromAssociates === true">
                  <div class="d-flex flex-column">
                    <span>
                      <label
                            class="font-weight-bold font-poppins"
                            style="font-size: small;"
                            for="selectClientExist"
                      >
                      Clientes existentes</label>
                    </span>
                    <span class="d-flex justify-content-center align-items-center">
                        <input
                              id="checkbox_select"
                              name="checkbox_select"
                              style="width: 24px; border: 1.5px solid black"
                              aria-label="checkbox_select"
                              type="checkbox"
                             (change)="toggleSelect($event.target)"
                        />
                        <select
                                id="selectClientExist"
                                name="selectClientExist"
                                class="form-control custom-select"
                                style="margin-right: -15px; margin-left:15px;"
                                formControlName="selectClientExist"
                                aria-label="selectClientExist"
                                autocomplete="off"
                                (change)="clientSelect($event.target.value)">
                          <option selected disabled>Clientes existentes</option>
                          <option *ngFor="let client of sortClientsByLastName(clientData.clients)" [value]="client.id">{{client.last_name}}{{client.last_name ? ', ' : ''}}{{client.first_name}} </option>
                        </select>
                      </span>
                    </div>
                  </ng-container>
                </div>
              <div *ngIf="data.typeAction" class="col-8 d-flex justify-content-end align-items-end ">
                <button class="btn mr-2 rounded-pill" style="height: 38px;width:150px;background-color: black; color: white;" (click)="closeModal()">
                CERRAR
                </button>

                <button (click)="_onSubmitClient($event)" class="btn rounded-pill " style="height: 38px;width:150px; color: white;background-color: #00d096;">
                  {{data.typeAction=="New" ? "CREAR" : "ACTUALIZAR"}}
                </button>
              </div>
          </div>
          </div>
        </accordion-group>
      </accordion>
    </div>


    <div class="col-4 col-md-4 col-lg-4 col-xl-4" *ngIf="!data.typeAction">
      <span class="mb-3" style="font-size: 1.65rem" [ngStyle]="{ 'color': formPaxesReservationData.getClientsSettingAppBooking?.clients_setting_global?.color_main_3 }"
        >RESUMEN</span
      >
      <div class="pb-5 pt-2 px-2" style="border-radius: 5px" [ngStyle]="{ 'background-color': formPaxesReservationData?.styleSidebar?.background_color }">
        <usb-summary-reservation [step]="step"
        [currencies]="currencies"
        [totalPasajeros]="totalPasajeros"
        [currencyAgency]="currencyAgency"
        [itineraryItems]="itineraryItems"
        [itineraryTotal]="itineraryTotal"
        [getClientsSettingAppBooking]="getClientsSettingAppBooking"
         [styleSidebar]="formPaxesReservationData.styleSidebar"
         [itinerary]="itinerary"
         (addFormEmitType)="addForm($event)">
        </usb-summary-reservation>
        <button
          (click)="_onSubmit(false, $event)"
          [disabled]="!isFormValid()"
          class="btn rounded-pill btn-block"
          style="height: 70px; cursor: pointer"
          [ngStyle]="{ 'background-color': formPaxesReservationData.getClientsSettingAppBooking?.clients_setting_global?.color_main_3 }"
        >
          <span *ngIf="permitedConfiguration">CONTINUAR</span>
          <span *ngIf="!permitedConfiguration">RESERVAR</span>
        </button>
      </div>
    </div>
  </div>
</form>

<div *ngIf="!loadedClientInfoForm" class="loading-container">
  <div class="spinner-border" role="status">
    <span class="sr-only">Cargando...</span>
  </div>
</div>

</div>
